/**
 * Client-side i18n. Fetches translations from /api/i18n
 * and provides lookup with parameter substitution.
 */
let messages = {};

/** localStorage key holding the user's language override ("de" | "en"), if any. */
export const LANG_OVERRIDE_KEY = "lang";

const SUPPORTED_LANGUAGES = ["de", "en"];

/**
 * The active UI language ("de" | "en"): the localStorage override if it is a
 * supported code, otherwise the server-rendered <html lang> (already normalized
 * to the supported set by game.html). The trailing guard keeps a malformed
 * attribute from leaking a non-supported code into the fetch URL.
 */
export function getActiveLanguage() {
  const override = localStorage.getItem(LANG_OVERRIDE_KEY);
  if (SUPPORTED_LANGUAGES.includes(override)) return override;
  return document.documentElement.lang === "de" ? "de" : "en";
}

/** Fetch translations from the server. Must be awaited before rendering. */
export async function loadMessages() {
  const lang = getActiveLanguage();
  const resp = await fetch(`/api/i18n?lang=${lang}`);
  messages = await resp.json();
  // Keep <html lang> in sync so the override (not just the server-detected
  // locale) is reflected for screen readers and subsequent getActiveLanguage reads.
  document.documentElement.lang = lang;
}

/**
 * Look up a translation by key. Supports {0}, {1}, ... placeholders.
 * Returns the key itself if no translation is found.
 */
export function t(key, ...args) {
  let msg = messages[key];
  if (msg === undefined) return key;
  for (let i = 0; i < args.length; i++) {
    msg = msg.replace(`{${i}}`, args[i]);
  }
  return msg;
}
